import React from 'react';
import "./Throat.css"; 
import DoctorImage from "./image/doctor.webp";
import AboutDoctor from '../AboutDoctor';


const ThroatDoctorDelhi = () => {
  return (
    <>
     <section className="bg-b">
     <style>
        {`
        section {
    position: relative;
    padding: 15px 0px !important;
}`}
      </style>
        <div className="container">
          <div className="content">
            <p>
            The throat, also known as the pharynx, is a muscular tube that carries food to the food pipe (esophagus) and air to the windpipe (trachea) and the voice box (larynx), making it an important part of a person’s respiratory and digestive systems. 

            </p>
            <p>The throat may be affected by different types of bacterial and viral infections, such as strep throat and cold, as well as other major disorders or conditions, such as throat cancer.

            </p>
            <p>A throat doctor is an ENT (ear, nose, and throat) doctor or otolaryngologist who specializes in the diagnosis and treatment of various throat conditions. </p>
            <p>If you have throat-related problems and are looking for the best throat doctor in Delhi, you should contact Dr. (Major) Rajesh Bhardwaj, Consultant ENT Specialist at MedFirst ENT Centre in Delhi. He is a well-known, award-winning throat specialist doctor in Delhi and has over three decades of experience in the diagnosis and management of throat disorders.</p>
          </div>
        </div>
      </section>
       <section className="specialist-section py-4 bg-light">
  <div className="container">
    <div className="text-center mb-4">
      <h6 className="section-subtitle text-danger text-center">OUR TEAM</h6>
      <h2 className="pq-section-subtitle sub-subtitle text-center">Meet Our Best ENT Specialist</h2>
     
    </div>
    
    <div className="row g-4 align-items-center">
      <div className="col-lg-5 col-md-6">
        <div className="specialist-image-container position-relative">
          <img
            src={DoctorImage}
            className="img-fluid rounded-3 shadow-lg"
            alt="Dr. (Major) Rajesh Bhardwaj"
          />
          
        </div>
      </div>

      <div className="col-lg-7 col-md-6">
        <div className="ps-md-4">
          {/* <h3 className="text-primary mb-3" style={{color: "rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important"}}>ENT Consultation, Surgeries & Treatment</h3> */}
          <h2 className="display-6 fw-bold text-dark mb-2 ">Dr. (Major) Rajesh Bhardwaj</h2>
          <p className="text-muted mb-4">
            <i className="fas fa-graduation-cap me-2"></i>
            MBBS (AFMC), MS, DNB, DLO, DHA
          </p>

          <div className="specialist-details">
            <div className="mb-4">
              <h4 className="d-flex align-items-center text-success mb-3">
                <i className="fas fa-stethoscope me-2"></i> Specialities
              </h4>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="fas fa-check-circle text-success me-2"></i>
                  Comprehensive ENT care
                </li>
              </ul>
            </div>

            <div className="mb-4">
              <h4 className="d-flex align-items-center text-success mb-3">
                <i className="fas fa-tools me-2"></i> Expert Skills
              </h4>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="fas fa-check-circle text-success me-2"></i>
                  Advanced ENT surgeries
                </li>
                <li className="mb-2">
                  <i className="fas fa-check-circle text-success me-2"></i>
                  Skilled in handling complex cases
                </li>
                <li className="mb-2">
                  <i className="fas fa-check-circle text-success me-2"></i>
                  Expertise in cochlear implants
                </li>
                <li className="mb-2">
                  <i className="fas fa-check-circle text-success me-2"></i>
                  Renowned for ethical practice and honest opinions
                </li>
              </ul>
            </div>

            <div className="mb-4">
              <h4 className="d-flex align-items-center text-success mb-3">
                <i className="fas fa-award me-2"></i> Experience
              </h4>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="fas fa-check-circle text-success me-2"></i>
                  30+ years in ENT care
                </li>
                <li className="mb-2">
                  <i className="fas fa-check-circle text-success me-2"></i>
                  Served 15 years in the Indian Army
                </li>
                <li className="mb-2">
                  <i className="fas fa-check-circle text-success me-2"></i>
                  Extensive clinical experience in major hospitals
                </li>
              </ul>
            </div>
          </div>
          
            {/* <button className="btn btn-primary btn-lg mt-3">
              Book an Appointment <i className="fas fa-arrow-right ms-2"></i>
            </button> */}
        </div>
      </div>
    </div>
  </div>
</section>


      <section className="expert-advice-section bg-light py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="card shadow-sm p-4">
                <h3 className="card-title text-success">
                  Choosing the Right Throat Doctor in Delhi
                </h3>
                <p className="card-text">
                  Some important factors need to be considered while choosing the
                  right throat doctor in Delhi to manage all your throat-related
                  problems easily. These factors are as follows:
                </p>
                <ul className="key-points">
                  <li>Qualifications and experience of the throat doctor</li>
                  <li>Reputation of the doctor</li>
                  <li>
                    The reputation of the clinic or hospital where the doctor
                    practices
                  </li>
                  <li>Services and facilities available</li>
                  <li>Patient testimonials and reviews</li>
                  <li>Approachable, honest, and empathetic</li>
                  <li>Success rates of the doctor</li>
                  <li>
                    Your comfort level with the doctor during the consultation
                    visit
                  </li>
                </ul>
                <p className="card-text">
                  Dr. (Major) Rajesh Bhardwaj from MedFirst ENT Centre uses
                  advanced medical technology and resources to offer personalized
                  care and treatment to his patients with successful results. His
                  expertise and skills, coupled with his compassionate treatment
                  approach, make him the best throat specialist in Delhi.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Our Experienced Throat Doctor in Delhi */}
      <section className="experienced-doctor-section py-5">
        <div className="container">
          <h2 className="pq-section-subtitle sub-subtitle text-center">
            Our Experienced Throat Doctor in Delhi
          </h2>
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="card shadow-sm p-4">
                <h3 className="card-title text-success">
                  Dr. (Major) Rajesh Bhardwaj
                </h3>
                <p className="card-text">
                  Dr. (Major) Rajesh Bhardwaj started MedFirst ENT Centre in
                  Delhi with the aim of providing top-quality, affordable
                  treatments to people suffering from ear, nose, and
                  throat-related problems.
                </p>
                <p className="card-text">
                  Dr. (Major) Rajesh Bhardwaj graduated from the reputed Armed
                  Forces Medical College (AFMC) in Pune. He graduated in the year
                  1982 and worked as an ENT specialist in the Indian Army for 15
                  years after that.
                </p>
                <p className="card-text">
                  He then decided to work as a private practitioner and started
                  MedFirst ENT Centre in the year 1997 after gaining years of
                  experience in some of the busiest hospitals of the armed
                  forces. He has also worked as an ENT consultant in several top
                  hospitals in Delhi.
                </p>
                <p className="card-text">
                  Dr. Bhardwaj offers honest, transparent, ethical,
                  patient-centric, and personalized treatment to all his
                  patients. He is the recipient of some of the top awards and
                  recognitions for his ENT services. Some major awards won by him
                  include the following:
                </p>
                <ul className="key-points">
                  <li>
                    Healthcare Ambassador award for spreading information to the
                    general public during Covid times – 2022
                  </li>
                  <li>
                    Best ENT Specialist Delhi at the Asia Healthcare Summit
                    Awards - 2020
                  </li>
                  <li>Distinguished Doctor’s Award – 2017</li>
                  <li>
                    Top Three Rated ENT Specialist of Delhi (a global,
                    independent global rating agency) – many years
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Conditions Treated by Our Throat Specialist */}
      <section className="conditions-section bg-light py-5">
        <div className="container">
          <h2 className="pq-section-subtitle sub-subtitle text-center">
            Conditions Treated by Our Throat Specialist
          </h2>
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="card shadow-sm p-4">
                <p className="card-text">
                  The various conditions treated at MedFirst ENT Centre by our
                  throat specialist are:
                </p>
                <ul className="key-points">
                  <li>Acid reflux (GERD)</li>
                  <li>Chronic cough</li>
                  <li>Dysphagia (difficulty swallowing)</li>
                  <li>Articulation and pronunciation problems</li>
                  <li>Feeding problems in infants and children</li>
                  <li>Epiglottitis</li>
                  <li>Foreign bodies in the throat, esophagus, or trachea</li>
                  <li>Hoarseness of voice</li>
                  <li>Hyperparathyroidism</li>
                  <li>Laryngitis</li>
                  <li>Inflammation of the tonsils or adenoids</li>
                  <li>Granulation tissue in the trachea</li>
                  <li>Lesions or masses in the mouth or throat region</li>
                  <li>
                    Laryngomalacia (the congenital softening of the larynx
                    tissues)
                  </li>
                  <li>Oromotor (oral motor) weakness</li>
                  <li>Pain on eating</li>
                  <li>Periodic fever syndrome</li>
                  <li>Pharyngitis</li>
                  <li>
                    Recurrent croup (a type of inflammation usually seen in
                    children that leads to barking cough)
                  </li>
                  <li>Strep throat (bacterial infection)</li>
                  <li>Recurrent strep throat</li>
                  <li>Restless sleep</li>
                  <li>Sleep apnea</li>
                  <li>
                    PANDAS (pediatric autoimmune neuropsychiatric disorder
                    associated with strep)
                  </li>
                  <li>Snoring</li>
                  <li>Speech delay</li>
                  <li>Stridor (noisy breathing in infants)</li>
                  <li>Larynx tumors</li>
                  <li>Throat tumors</li>
                  <li>Subglottic stenosis (narrowing of the airway)</li>
                  <li>Throat pain</li>
                  <li>Thyroid disorders</li>
                  <li>Tongue tie</li>
                  <li>Quinsy (throat and peritonsillar abscess)</li>
                  <li>Tonsil stones</li>
                  <li>Tonsil asymmetry</li>
                  <li>Acute or chronic tonsillitis</li>
                  <li>Tracheomalacia (collapse of the airway)</li>
                  <li>Velopharyngeal insufficiency</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: When to See a Throat Doctor? */}
      <section className="when-to-see-section py-5">
        <div className="container">
          <h2 className="pq-section-subtitle sub-subtitle text-center">
            When to See a Throat Doctor?
          </h2>
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="card shadow-sm p-4">
                <p className="card-text">
                  You need to see a throat doctor if you notice any of the
                  following symptoms:
                </p>
                <ul className="key-points">
                  <li>Throat pain</li>
                  <li>Visible white spots in the throat or tonsils</li>
                  <li>Persistent sore throat</li>
                  <li>Loss of voice</li>
                  <li>Difficulty swallowing</li>
                  <li>Shortness of breath or problems with breathing</li>
                  <li>Chronic bad breath or bad taste in the mouth</li>
                  <li>Throat injury</li>
                  <li>Foreign body stuck in the throat</li>
                  <li>Snoring or sleep apnea</li>
                  <li>Recurrent mouth ulcers</li>
                  <li>Lumps or growths in the throat</li>
                </ul>
                <p className="card-text mt-4">
                  Dr. (Major) Rajesh Bhardwaj is the best throat specialist
                  doctor in Delhi. He will assess your symptoms carefully to
                  provide a precise and early diagnosis and treatment plan
                  depending on the severity and type of throat disorder you have.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: Common Procedures Performed by Our Throat Doctor */}
      <section className="procedures-section bg-light py-5">
        <div className="container">
          <h2 className="pq-section-subtitle sub-subtitle text-center">
            Common Procedures Performed by Our Throat Doctor
          </h2>
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="card shadow-sm p-4">
                <p className="card-text">
                  The most common procedures performed by our throat doctor at
                  MedFirst ENT Centre are:
                </p>
                <ul className="key-points">
                  <li>
                    <strong>Bronchoscopy:</strong> This is a minimally invasive
                    procedure done by inserting a long tube with a camera on one
                    end through the nose or mouth of a person for diagnosis of a
                    lung problem, removal of a foreign body, or to take a tissue
                    sample for biopsy.
                  </li>
                  <li>
                    <strong>Direct laryngoscopy:</strong> This procedure is
                    performed to examine and treat problems in the throat or
                    larynx.
                  </li>
                  <li>
                    <strong>Biopsy and excision of oral tumors:</strong> This
                    procedure involves the removal of a tissue sample for
                    evaluation (biopsy) and the surgical removal of the oral
                    tumors.
                  </li>
                  <li>
                    <strong>Esophagoscopy:</strong> The procedure is used to
                    examine the esophagus and usually helps in the diagnosis of
                    dysphagia or foreign body removal.
                  </li>
                  <li>
                    <strong>Excision of mucosal lesions and masses:</strong>{" "}
                    Masses or mucosal lesions in the tongue, lip, or oral cavity
                    can be removed by a throat specialist.
                  </li>
                  <li>
                    <strong>Excision of lingual tonsils or tongue base:</strong>{" "}
                    The lingual tonsil located at the base of the tongue may be
                    removed to create an improved airway or treat obstructive
                    sleep apnea/snoring issues in a person.
                  </li>
                  <li>
                    <strong>Removal of oral mucocele:</strong> An oral mucocele
                    is a type of cyst that may develop in the oral cavity and may
                    require removal when it becomes enlarged.
                  </li>
                  <li>
                    <strong>Incision and drainage of abscess:</strong> Untreated
                    strep throat or tonsillitis may lead to a bacterial
                    infection, known as a peritonsillar abscess. Another type of
                    bacterial infection in the back of the throat that leads to
                    pus collection is known as a retropharyngeal abscess. A
                    throat doctor performs incision and drainage procedures for
                    these types of abscesses.
                  </li>
                  <li>
                    <strong>Tracheal or subglottic balloon dilation:</strong>{" "}
                    This procedure involves widening the narrowed air passageway
                    due to conditions like subglottic stenosis or recurrent
                    croup.
                  </li>
                  <li>
                    <strong>Supraglottoplasty:</strong> This procedure helps
                    treat laryngomalacia or softened larynx.
                  </li>
                  <li>
                    <strong>Frenotomy:</strong> Also known as tongue tie release
                    surgery, this procedure helps treat ankyloglossia or tongue
                    tie, in which an abnormal, thick, and short band of tissue
                    connects the tip of the tongue to the floor of the mouth.
                  </li>
                  <li>
                    <strong>Tonsillectomy with or without adenoidectomy:</strong>{" "}
                    This is a surgical procedure performed to remove the inflamed
                    tonsils. The adenoids (glands situated in the roof of the
                    mouth) may also be removed at the same time to improve
                    breathing. This procedure is known as adenoidectomy.
                  </li>
                  <li>
                    <strong>Vocal cord surgery:</strong> Various vocal cord
                    diagnostic procedures and surgeries may be performed by our
                    throat doctor.
                  </li>
                  <li>
                    <strong>Uvulopalatopharyngoplasty:</strong> This is a
                    procedure that maximizes the capacity of the airway in the
                    throat while preventing the collapse of the tissues to treat
                    obstructive sleep apnea.
                  </li>
                  <li>
                    <strong>Transoral robotic surgery:</strong> This is a
                    minimally invasive surgery performed using robotic arms
                    controlled by the throat specialist.
                  </li>
                </ul>
                <p className="card-text mt-4">
                  Dr. (Major) Rajesh Bhardwaj specializes in the treatment of all
                  types of throat conditions, and he is the best doctor for
                  throat infection in Delhi, as well as other throat disorders.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      
          <AboutDoctor />

    
    </>
  );
};

export default ThroatDoctorDelhi;